/* eslint-disable */
import {CircularProgress} from '@material-ui/core'
import * as React from 'react'

const Preloader = (props: any): any =>
  <div className='preloader'>
    <CircularProgress size={40} {...props.preloaderProps} style={{color: '#00b181'}}/>
  </div>

export default Preloader